import styles from './styles.module.scss';
import { AutomatedAuditLoader, Button,  PasswordInput } from '@common/components';
import { ChevronDown, ChevronUp, Link, LogIn, MessageSquare, Trash2 } from '@geist-ui/icons';
import { Accordion, ActionIcon, Badge, Box, Menu, Card, Divider, TextInput, FileInput, Flex, Checkbox, Group, Modal, MultiSelect, Space, Text, Title, Tooltip, UnstyledButton, Select, NumberInput, Textarea } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { ChangeEvent, FC, useMemo, useRef, useState } from 'react';
import AddOrganization from './AddOrganization/page';
import { currentAction, deleteClientFromOrganisation, deleteOrganizationfun, getClientOrganizations, getJoinedOrganization, updateCurrent, useAppDispatch, useAppSelector } from 'src/store';
import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import CreateOrganization from './CreateOrganization/page';
import InviteCompany from './InviteCompany/page';
import Notification from '../Notification';
import { apiInstance } from 'src/services';
import { useForm, yupResolver } from '@mantine/form';
import * as yup from 'yup';
import { validationPattern } from '@common/helpers';
import { useAlert,useFormFocus } from '@common/hooks';
import classNames from 'classnames';
import { Button as ButtonMantin } from '@mantine/core';
import { Checkbox as CheckboxMantin } from '@common/components';
import SitemapTable from '../SitemapPage/sitemapTable';
import Permissions from '../Permissions';
import MainAccordion from './accordion';


interface MyOrganisationsProp{
    page?:string
    panel?:string
    siteUUID?:string,
    focusTitle?:boolean
}

const MyOrganisations: FC<MyOrganisationsProp> = ({
    page = '',
    panel,
    siteUUID,
    focusTitle = true
  }): JSX.Element => {
    const [addOrganizationState, setAddOrganizationState] = useState(false)
    const [createOrganization, setCreateOrganization] = useState(false)
    const [inviteCompany, setInviteCompany] = useState(false)


    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { showAlert } = useAlert();
    const user = useAppSelector((state) => state.user.data, shallowEqual);
    const [t] = useTranslation('account');
    const { loadingUserOrganizations,
        ClientOrganizations,
        deleteOrganizationError,
        OrgsJoined,
        loadingOrgsJoined,
        loadingClientOrganizations,
        deleteOrgClient,
        updateNameCompany
    } = useAppSelector((state) => state.organization, shallowEqual);
    const { pageTab } = useParams();
    const hiddenRef = useRef<HTMLDivElement>(null); // Hidden element for initial focus reset

    const [ thesListOfOrganizations, setThesListOfOrganizations] = useState<any>([]);

    const tenantId = user.tenantId
    useEffect(() => {
        if ( page != 'account-details' ) {
            // dispatch(getJoinedOrganization({ company_id: user.company_id }));
            dispatch(getClientOrganizations({  }));
            // console.log(`test organization`);
            document.title = 'Manage Organizations';
        }
        return () => {
            setCreateOrganization(false)
            setAddOrganizationState(false)
        };
    }, []);

    useEffect(() => {
        if ( page != 'account-details' ) {
            dispatch(getClientOrganizations({ }));
        }
    }, [deleteOrgClient]);

    useEffect(() => {
        if (  page === 'account-details'  ) return;
        
        if (!ClientOrganizations) return;

        setThesListOfOrganizations(ClientOrganizations);
    }, [ClientOrganizations]);

    useEffect(() => {
     if(!updateNameCompany){
        return;
     }
     if ( page != 'account-details' ) {
        dispatch(getClientOrganizations({ }));
    }
    }, [updateNameCompany])
    


    // useEffect(() => {
    //     if (!tenantId) {
    //         return;
    //     }

    //     if (page == 'account-details' ) return;
    //     dispatch(getClientOrganizations({ tenantId }));
    // }, [user]);


    const removeOrganisation = (id: any) => {

        if (id == user.organizationsId) {
            dispatch(deleteOrganizationfun({
                organisation_id: id
            }));
            // localStorage.removeItem('currentUserOrganizationInfo');
        } else {
            dispatch(deleteClientFromOrganisation({
                company_id: id,
            }))
        }

        dispatch(currentAction());
        if (deleteOrganizationError != "") {
            showAlert({
                id: String(id),
                title: `Enable To Delete ${entity}`,
                message: 'Somthing went wrong!!',
                variant: 'error',
            });
        }
    };

    const onNavigateBtnHandler = (organizationId: number, clickType: string) => () => {
        console.log(clickType, organizationId);

        if (clickType == "view") {
            navigate(`/account/organisations/${organizationId}/companies`);
            return;
        }
        navigate(`${organizationId}`);
    }

    const titleRef = useRef<HTMLHeadingElement>(null)
    function resetFocus() {
        titleRef?.current?.setAttribute('tabindex', '-1');
        titleRef?.current?.focus();
    }
    useEffect(() => {

        if (pageTab !== 'Organisations') {
            setCreateOrganization(false)
            setAddOrganizationState(false)
        }
    }, [pageTab])


    // tabs dropdowns system state
    const [manageUsersTabIndex, setManageUsersTabIndex] = useState<number | null>(null)
    const [isIsManageUsersTabOpen, setIsManageUsersTabOpen] = useState<boolean>(false)

    const navigateToPayment = (): void => {
        apiInstance.get('payment/portal').then((res) => {
          window.location = res.data.url;
        });
      };
      const [limitOrg, setLimitOrg] = useState(false);

    // useEffect(() => {
    
    //     if(ClientOrganizations){
    //         setLimitOrg(ClientOrganizations.length >= 10);
    //     }

    // }, [ClientOrganizations]);
    
    const isAccountPage = page == "account-details";
    const entity = isAccountPage ? 'Company' : 'Organisation';
    const entities = isAccountPage ? 'Companies' : 'Organisations';
    const paddingcont = isAccountPage ? '0' : '3rem';
 
  

    useEffect(() => {
        resetFocus()
        window.addEventListener('keydown' , handleKeyForHeadingLevelOne)
        return () => {
          window.removeEventListener('keydown' , handleKeyForHeadingLevelOne)
        }
      }, [pageTab]);

    function handleKeyForHeadingLevelOne(event: any) {    
        // console.log( event.keyCode );
        
        if ( event.keyCode === 39  ) {
            resetFocus()
        }
    }

    useEffect(() => {
        // Set focus to the hidden element first
        if (hiddenRef.current) {
          hiddenRef.current.focus();
        }
        // After a short delay, set focus to the active tab content
        setTimeout(() => {
          window.addEventListener('keydown' , handleKeyForHeadingLevelOne)
          resetFocus()
          return () => {
            window.removeEventListener('keydown' , handleKeyForHeadingLevelOne)
          }
        }, 100);
      }, [pageTab]);
      const externalCompanies = [
        {
            id:'1',
            name:'Company 1',
        },
        {
            id:'2',
            name:'Company 2',
        },
        {
            id:'3',
            name:'Company 3',
        },
        {
            id:'4',
            name:'Company 4',
        }
      ]
    return (
        <div style={{ width: '100%', flex: '1', padding: paddingcont }}>
            <div ref={hiddenRef} tabIndex={-1} style={{ position: 'absolute', left: '-9999px' }} />
     
            {/* Section for organization invites */}
            <div className={styles.wrapper}>
                    <Flex justify={"space-between"}>
                                <Title ref={focusTitle ? titleRef : null } id='myorganizationTitle' color={'#264547'} mb={'18px'} order={1}>
                            {
                                isAccountPage ? 'Companies' :
                                ' External Companies'
                            }
                            </Title>
                            {
                                isAccountPage ?
                            <Flex gap="sm" role="tablist">
                                <Button
                                    buttonStyle={{ cursor: "pointer" }}
                                    color="dark-green"
                                    onClick={() => {
                                        if (limitOrg) {
                                            navigateToPayment();
                                            return;
                                        }
                                        setCreateOrganization(true);
                                        setAddOrganizationState(false);
                                        setInviteCompany(false);
                                    }}
                                    aria-selected={createOrganization}
                                    aria-controls="panel-create-organization"
                                     
                                    {...{ role :  "tab"  }}
                                >
                                    {limitOrg
                                        ? `Upgrade your plan to add more ${entities}`
                                        : t('notificationTab.createOrganization', { entity })}
                                </Button>

                                <Button
                                    buttonStyle={{ cursor: "pointer" }}
                                    color="gray-light"
                                    onClick={() => {
                                        setInviteCompany(true);
                                        setAddOrganizationState(false);
                                        setCreateOrganization(false);
                                    }}
                                    aria-selected={inviteCompany}
                                    aria-controls="panel-invite-company"
                                    {...{ role :  "tab"}}
                                >
                                    {t('notificationTab.inviteCompany.title')}
                                </Button>
                            </Flex>
                            : null
                            }

                        </Flex>
                
                            
               
                {
                   !isAccountPage ? null :  createOrganization && (
                        <CreateOrganization 
                            entity = {entity}
                            entities = {entities}
                            onCloseFun={() => {
                                setCreateOrganization(false)
                                resetFocus()
                            }}
                        />
                    )
                }
                {
                    !isAccountPage ? null :  (inviteCompany &&
                        <InviteCompany onCloseFun={() => {
                            setInviteCompany(false)
                            resetFocus()
                        }}
                        />
                    )
                }
                {/* {
                   isAccountPage ?
                        null 
                        :
                        <Notification  
                        isAccountPage={isAccountPage}
                        entity = {entity}
                        entities = {entities}
                        />
                } */}
            
                <Space h="lg" />

                <div className={styles.sectionWrraper}>
                    {/* {
                         isAccountPage ? 
                         <Flex>
                             <Select
                             width={'40%'}
                            //  label="Your favorite library"
                             placeholder="Chose Category"
                             data={['React', 'Angular', 'Vue', 'Svelte']}
                             />         
                         </Flex>
                         
                         : null
                    } */}
                
                {
                    loadingUserOrganizations ?

                        <Flex gap={"md"} >
                            <AutomatedAuditLoader />
                            <span> {`Getting ${entity}`}</span>
                        </Flex>
                        :
                                                    
                        (
                            isAccountPage ?
                            <>
                               {/* <Flex w={"100%"} justify={"end"} align={"center"} gap={"sm"}>
                                    <p>2 users of 100 </p>
                                    <Button color='gray-light'>Add Users</Button>
                                </Flex> */}
                                <MainAccordion amIAdmin={false} isAccountPage={isAccountPage} siteUUID={siteUUID} panel={panel}  />
                            </>
                            :
                            <MainAccordion amIAdmin={false} isAccountPage={isAccountPage} siteUUID={siteUUID} panel={panel}  />

                            // <table className={styles.table} >
                            //     <thead>
                            //         <tr>
                            //             <th style={{ width: '10%'}} ></th>
                            //             <th style={{ width: '30%'}} >Company</th>
                            //             <th style={{ width: '30%'}} >Role</th>
                            //             <th style={{ width: '30%'}} >{t('notificationTab.tabel.actions')}</th>
                            //         </tr>
                            //     </thead>
                            //     <tbody>
                            //         {
                                        
                            //            !isAccountPage &&  thesListOfOrganizations?.length ?
                            //            thesListOfOrganizations?.map((organization: any, index: any) => (
                            //                 <>
                            //                     <tr key={organization?.id ?? organization?.organization_id} style={organization?.role == "Admin" ? { fontSize: "20px", fontWeight: "bold" } : undefined}>
                            //                         <td>
                            //                             <UnstyledButton className={styles.circelBorder}
                            //                                 onClick={() => {
                            //                                     setIsManageUsersTabOpen(!isIsManageUsersTabOpen)
                            //                                     setManageUsersTabIndex(index)
                            //                                 }}>
                            //                                 { (isIsManageUsersTabOpen && index == manageUsersTabIndex) ? <ChevronUp /> : <ChevronDown />}
                            //                             </UnstyledButton>

                            //                         </td>
                            //                         <td className={styles.client_click}>
                            //                              {organization?.company_name }
                            //                         </td>
                            //                         <td>
                            //                          <Badge color="blue">Viewer</Badge>

                            //                         </td>
                            //                         <td className={styles.flex}>
                            //                             {/* <UnstyledButton className={styles['delete-btn']} onClick={onNavigateBtnHandler(organization.id, 'view')}
                            //                                 aria-label='view Companies'
                            //                             >
                            //                                 <th>  { isAccountPage ? "View Details" : t('notificationTab.tabel.viewCompany')} </th>

                            //                             </UnstyledButton> */}

                            //                             {/* <UnstyledButton className={styles['delete-btn']} onClick={onNavigateBtnHandler(organization.id,'access')} 
                            //                         aria-label='Grant access'
                            //                         >
                            //                         Grant access
                            //                     </UnstyledButton> */}
                            //                             <Tooltip label="leave organisation" >

                            //                             <UnstyledButton className={styles['delete-btn']} onClick={() => removeOrganisation(organization.id)}
                            //                                 aria-label='leave organisation'
                            //                                 >
                            //                                 <LogIn color="#A80000" /> Leave
                            //                             </UnstyledButton>
                            //                             </Tooltip>
                            //                         </td>
                            //                     </tr>

                            //                     {isIsManageUsersTabOpen && manageUsersTabIndex == index &&
                            //                         <tr >
                            //                             <td colSpan={4}>
                            //                             {/* <Flex w={"100%"} justify={"end"} align={"center"} gap={"sm"} >
                            //                                 <p>2 users of 100 </p>
                            //                                 <Button color='gray-light'>Add Users</Button>
                            //                             </Flex> */}
                            //                             <MainAccordion  amIAdmin={ organization?.role == 'Admin' ? true : false}   isAccountPage={isAccountPage} organizationId = { organization.id ?? organization?.organization_id } />
                            //                             </td>
                            //                         </tr>
                            //                     }
                            //                     {/* {
                            //                         isIsManageUsersTabOpen && manageUsersTabIndex == index &&
                            //                         <tr>
                            //                             <td colSpan={4}>
                            //                                 <div className={styles.settings}>
                            //                                     <div className={styles.sectionWrapper}>
                                                                    
                            //                                         <UsersListComponent /> 
                            //                                     </div>
                            //                                 </div>
                            //                             </td>
                            //                         </tr>
                            //                     } */}

                            //                 </>
                            //             )) :
                            //             <tr>
                            //                 <td colSpan={4} style={{ textAlign: 'center' }}>
                            //                 <Flex direction={"column"} gap={"sm"} justify={"center"} align={"center"}>
                            //                     <MessageSquare/>
                            //                     <span>You have yet to join an company</span>
                            //                 </Flex>
                            //                 </td>
                            //             </tr>

                            //         }



                                   
                            //     </tbody>
                            // </table>
                        )
                }
                </div>


                <Space h="lg" />
                {/* <Title className={styles['second-heading']} color={'#264547'} mb={'18px'} order={1}>
                    {t('notificationTab.joindeOrganization')}
                </Title> */}
                {/* <table className={styles.table} >
                    <thead>
                        <tr>
                            <th>{t('notificationTab.tabel.name')}</th>
                            <th>{t('notificationTab.tabel.email')}</th>
                            <th>{t('notificationTab.tabel.actions')}</th>

                        </tr>
                    </thead>
                    <tbody>
                        {loadingOrgsJoined ?

                            <Flex gap={"md"} >
                                <AutomatedAuditLoader />
                                <span> {'Getting organisation'}</span>
                            </Flex>
                            :


                            OrgsJoined && OrgsJoined.length > 0 ? (
                                OrgsJoined.map((organization: any, index: any) => {
                                    if (organization?.role !== "Admin") {
                                        // sethasJoinedOrganization(true)
                                        return (
                                            <tr key={organization?.id} style={organization?.role === "Admin" ? { fontSize: "20px", fontWeight: "bold", textDecoration: "underline" } : undefined}>
                                                <td>
                                                    {organization?.organization_name}
                                                </td>
                                                <td> {organization?.company_owner_email}</td>
                                                <td className={styles.flex}>
                                                    <UnstyledButton className={styles['delete-btn']} onClick={() => navigate(`${organization?.organization_id}/granted-websites?company_id=${organization?.company_id}`)}
                                                        aria-label='view websites'
                                                    >
                                                        {t('notificationTab.tabel.viewSites')}
                                                    </UnstyledButton>

                                                    <UnstyledButton className={styles['delete-btn']} onClick={() => navigate(`${organization?.organization_id}?company_id=${organization?.company_id}`)} aria-label='Grant access'
                                                    >
                                                        {t('notificationTab.tabel.grantAcess')}
                                                    </UnstyledButton>

                                                    <UnstyledButton className={styles['delete-btn']} onClick={() => removeOrganisation(organization.organization_id)}
                                                        aria-label='Delete organisation'
                                                    >
                                                        <Trash2 color="#A80000" />
                                                    </UnstyledButton>
                                                </td>
                                            </tr>
                                        );
                                    }

                                })
                            ) : null
                        }
                    </tbody>
                </table> */}
            </div>
        </div>
    );
}

export default MyOrganisations;


